import { buildSettlementPeriods } from "./calendar-date";
import { WorkPolicyFormErrors, WorkPolicyFormValue } from "./hooks/use-work-policy-form";
import {
  ErrorText,
  Field,
  FormGrid,
  FormSection,
  InlineChoice,
  PreviewList
} from "./work-type-management.styles";

interface SelectiveRuleSectionProps {
  value: WorkPolicyFormValue;
  errors: WorkPolicyFormErrors;
  onChange: <K extends keyof WorkPolicyFormValue>(
    field: K,
    value: WorkPolicyFormValue[K]
  ) => void;
  readOnly?: boolean;
}

export const SelectiveRuleSection = ({
  value,
  errors,
  onChange,
  readOnly = false
}: SelectiveRuleSectionProps) => {
  let periods: ReturnType<typeof buildSettlementPeriods> = [];
  let previewError = "";
  const previewDate = value.settlementPreviewDate ||
    (value.policyKind === "BASE" ? value.effectiveStartDate : "");
  if (previewDate) {
    try {
      periods = buildSettlementPeriods(previewDate, 3);
    } catch (error) {
      previewError = error instanceof Error ? error.message : "정산 기간을 계산할 수 없습니다.";
    }
  }

  return (
    <FormSection>
      <legend>선택적 근로시간제 추가 설정</legend>
      <p>적용 시작일의 일자를 기준으로 매월 정산 구간을 나눕니다.</p>
      <InlineChoice>
        <label>
          <input
            type="checkbox"
            checked={value.selectiveCoreEnabled}
            disabled={readOnly}
            onChange={event => {
              onChange("selectiveCoreEnabled", event.currentTarget.checked);
              if (!event.currentTarget.checked) {
                onChange("selectiveCoreStart", "");
                onChange("selectiveCoreEnd", "");
              }
            }}
          />
          의무 코어타임 사용
        </label>
      </InlineChoice>
      {value.selectiveCoreEnabled && (
        <FormGrid>
          <Field>
            의무 코어타임 시작
            <input
              id="work-policy-selectiveCoreStart"
              type="time"
              value={value.selectiveCoreStart}
              disabled={readOnly}
              aria-invalid={Boolean(errors.selectiveCoreStart)}
              aria-describedby={errors.selectiveCoreStart ? "work-policy-selectiveCoreStart-error" : undefined}
              onChange={event => onChange("selectiveCoreStart", event.currentTarget.value)}
            />
          </Field>
          <Field>
            의무 코어타임 종료
            <input
              id="work-policy-selectiveCoreEnd"
              type="time"
              value={value.selectiveCoreEnd}
              disabled={readOnly}
              aria-invalid={Boolean(errors.selectiveCoreStart)}
              aria-describedby={errors.selectiveCoreStart ? "work-policy-selectiveCoreStart-error" : undefined}
              onChange={event => onChange("selectiveCoreEnd", event.currentTarget.value)}
            />
          </Field>
        </FormGrid>
      )}
      {errors.selectiveCoreStart && <ErrorText id="work-policy-selectiveCoreStart-error">{errors.selectiveCoreStart}</ErrorText>}
      <Field>
        정산 미리보기 기준일
        <input
          type="date"
          value={previewDate}
          disabled={readOnly}
          onChange={event => onChange("settlementPreviewDate", event.currentTarget.value)}
        />
        <small>정산 구간 확인용이며 저장되는 정책 값에는 포함하지 않습니다.</small>
      </Field>
      {previewError && <ErrorText>{previewError}</ErrorText>}
      {periods.length > 0 && (
        <PreviewList aria-label="정산 기간 미리보기">
          {periods.map(period => (
            <li key={period.startDate}>
              <strong>{period.startDate}</strong> ~ {period.endDate}
              {period.clamped ? " · 다음 시작일 월말 보정" : ""}
            </li>
          ))}
        </PreviewList>
      )}
    </FormSection>
  );
};
